import React from 'react';

import type {
  GraphId,
  GraphScrubbedEvent,
} from 'containers/ForecastDataVisualizer/GraphTooltips/GraphTooltipProvider/GraphTooltipProvider';
import {
  useActiveSpectraLeftPosition,
  useActiveSpectraLeftNowPosition,
  useActiveSpectraTimeLabel,
  useActiveSpectraTimestamp,
} from 'utils/globalGraphState/globalSwellSpectraState';

import ForecastGraphTimelineSlider from './ForecastGraphTimelineSlider';

interface Props {
  customWidth?: number;
  graphWidth: number;
  leftLastDataPointPosition?: number;
  renderTooltip: (xPercentage: number, graphId: GraphId) => void;
  trackGraphScrubbed: GraphScrubbedEvent;
  numberOfDays: number;
  utcOffset: number;
}

const ForecastGraphSlider: React.FC<Props> = ({
  customWidth,
  graphWidth,
  leftLastDataPointPosition,
  renderTooltip,
  trackGraphScrubbed,
  numberOfDays,
  utcOffset,
}) => {
  const [leftNowPosition] = useActiveSpectraLeftNowPosition();
  const [leftPosition] = useActiveSpectraLeftPosition();
  const [timestamp] = useActiveSpectraTimestamp();
  const [timeLabel] = useActiveSpectraTimeLabel();

  return (
    <ForecastGraphTimelineSlider
      customWidth={customWidth}
      dataTestId="forecast-graph-slider"
      graphId="spectra"
      graphWidth={graphWidth}
      leftLastDataPointPosition={leftLastDataPointPosition}
      leftNowPosition={leftNowPosition}
      leftPosition={leftPosition}
      numberOfDays={numberOfDays}
      renderTooltip={renderTooltip}
      timeLabel={timeLabel}
      timestamp={timestamp}
      trackGraphScrubbed={trackGraphScrubbed}
      utcOffset={utcOffset}
    />
  );
};

export default React.memo(ForecastGraphSlider);
